import { PageRequest, PageResponse } from "../../../cosmos/base/query/v1beta1/pagination";
import { FeePayContract } from "./feepay";
import { Params } from "./genesis";
import { BinaryReader, BinaryWriter } from "../../../binary";
/** QueryFeePayContract retrieves a single fee pay contract */

/** QueryFeePayContract retrieves a single fee pay contract */

/** QueryFeePayContract retrieves a single fee pay contract */

/** QueryFeePayContractResponse defines the response for retrieving a single fee pay contract */

/** QueryFeePayContractResponse defines the response for retrieving a single fee pay contract */

/** QueryFeePayContractResponse defines the response for retrieving a single fee pay contract */

/** Message for querying a list of fee pay contracts */

/** Message for querying a list of fee pay contracts */

/** Message for querying a list of fee pay contracts */

/** The response for querying all fee pay contracts */

/** The response for querying all fee pay contracts */

/** The response for querying all fee pay contracts */

/** Message for querying the number of uses on a fee pay contract by wallet */

/** Message for querying the number of uses on a fee pay contract by wallet */

/** Message for querying the number of uses on a fee pay contract by wallet */

/** The response for querying the number of uses on a fee pay contract by wallet */

/** The response for querying the number of uses on a fee pay contract by wallet */

/** The response for querying the number of uses on a fee pay contract by wallet */

/** Message for querying if a wallet is eligible for fee pay contract interactions */

/** Message for querying if a wallet is eligible for fee pay contract interactions */

/** Message for querying if a wallet is eligible for fee pay contract interactions */

/** The response for querying if a wallet is eligible for fee pay contract interactions */

/** The response for querying if a wallet is eligible for fee pay contract interactions */

/** The response for querying if a wallet is eligible for fee pay contract interactions */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsRequest is the request type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

/** QueryParamsResponse is the response type for the Query/Params RPC method. */

function createBaseQueryFeePayContract() {
  return {
    contractAddress: ""
  };
}
export const QueryFeePayContract = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContract",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContract();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre;
    const message = createBaseQueryFeePayContract();
    message.contractAddress = (_object$contractAddre = object.contractAddress) !== null && _object$contractAddre !== void 0 ? _object$contractAddre : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayContract();
    if (object.contract_address !== undefined && object.contract_address !== null) {
      message.contractAddress = object.contract_address;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContract.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContract.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContract.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContract",
      value: QueryFeePayContract.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayContractResponse() {
  return {
    feePayContract: undefined
  };
}
export const QueryFeePayContractResponse = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContractResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.feePayContract !== undefined) {
      FeePayContract.encode(message.feePayContract, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContractResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.feePayContract = FeePayContract.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryFeePayContractResponse();
    message.feePayContract = object.feePayContract !== undefined && object.feePayContract !== null ? FeePayContract.fromPartial(object.feePayContract) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayContractResponse();
    if (object.fee_pay_contract !== undefined && object.fee_pay_contract !== null) {
      message.feePayContract = FeePayContract.fromAmino(object.fee_pay_contract);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.fee_pay_contract = message.feePayContract ? FeePayContract.toAmino(message.feePayContract) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContractResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContractResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContractResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContractResponse",
      value: QueryFeePayContractResponse.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayContracts() {
  return {
    pagination: undefined
  };
}
export const QueryFeePayContracts = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContracts",
  encode(message, writer = BinaryWriter.create()) {
    if (message.pagination !== undefined) {
      PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContracts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.pagination = PageRequest.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryFeePayContracts();
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageRequest.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayContracts();
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageRequest.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.pagination = message.pagination ? PageRequest.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContracts.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContracts.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContracts.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContracts",
      value: QueryFeePayContracts.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayContractsResponse() {
  return {
    feePayContracts: [],
    pagination: undefined
  };
}
export const QueryFeePayContractsResponse = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContractsResponse",
  encode(message, writer = BinaryWriter.create()) {
    for (const v of message.feePayContracts) {
      FeePayContract.encode(v, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContractsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.feePayContracts.push(FeePayContract.decode(reader, reader.uint32()));
          break;
        case 2:
          message.pagination = PageResponse.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$feePayContrac;
    const message = createBaseQueryFeePayContractsResponse();
    message.feePayContracts = ((_object$feePayContrac = object.feePayContracts) === null || _object$feePayContrac === void 0 ? void 0 : _object$feePayContrac.map(e => FeePayContract.fromPartial(e))) || [];
    message.pagination = object.pagination !== undefined && object.pagination !== null ? PageResponse.fromPartial(object.pagination) : undefined;
    return message;
  },
  fromAmino(object) {
    var _object$fee_pay_contr;
    const message = createBaseQueryFeePayContractsResponse();
    message.feePayContracts = ((_object$fee_pay_contr = object.fee_pay_contracts) === null || _object$fee_pay_contr === void 0 ? void 0 : _object$fee_pay_contr.map(e => FeePayContract.fromAmino(e))) || [];
    if (object.pagination !== undefined && object.pagination !== null) {
      message.pagination = PageResponse.fromAmino(object.pagination);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    if (message.feePayContracts) {
      obj.fee_pay_contracts = message.feePayContracts.map(e => e ? FeePayContract.toAmino(e) : undefined);
    } else {
      obj.fee_pay_contracts = [];
    }
    obj.pagination = message.pagination ? PageResponse.toAmino(message.pagination) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContractsResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContractsResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContractsResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContractsResponse",
      value: QueryFeePayContractsResponse.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayContractUses() {
  return {
    contractAddress: "",
    walletAddress: ""
  };
}
export const QueryFeePayContractUses = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContractUses",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }
    if (message.walletAddress !== "") {
      writer.uint32(18).string(message.walletAddress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContractUses();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;
        case 2:
          message.walletAddress = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre2, _object$walletAddress;
    const message = createBaseQueryFeePayContractUses();
    message.contractAddress = (_object$contractAddre2 = object.contractAddress) !== null && _object$contractAddre2 !== void 0 ? _object$contractAddre2 : "";
    message.walletAddress = (_object$walletAddress = object.walletAddress) !== null && _object$walletAddress !== void 0 ? _object$walletAddress : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayContractUses();
    if (object.contract_address !== undefined && object.contract_address !== null) {
      message.contractAddress = object.contract_address;
    }
    if (object.wallet_address !== undefined && object.wallet_address !== null) {
      message.walletAddress = object.wallet_address;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.wallet_address = message.walletAddress;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContractUses.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContractUses.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContractUses.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContractUses",
      value: QueryFeePayContractUses.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayContractUsesResponse() {
  return {
    uses: BigInt(0)
  };
}
export const QueryFeePayContractUsesResponse = {
  typeUrl: "/juno.feepay.v1.QueryFeePayContractUsesResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.uses !== BigInt(0)) {
      writer.uint32(8).uint64(message.uses);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayContractUsesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.uses = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryFeePayContractUsesResponse();
    message.uses = object.uses !== undefined && object.uses !== null ? BigInt(object.uses.toString()) : BigInt(0);
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayContractUsesResponse();
    if (object.uses !== undefined && object.uses !== null) {
      message.uses = BigInt(object.uses);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.uses = message.uses ? message.uses.toString() : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayContractUsesResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayContractUsesResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayContractUsesResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayContractUsesResponse",
      value: QueryFeePayContractUsesResponse.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayWalletIsEligible() {
  return {
    contractAddress: "",
    walletAddress: ""
  };
}
export const QueryFeePayWalletIsEligible = {
  typeUrl: "/juno.feepay.v1.QueryFeePayWalletIsEligible",
  encode(message, writer = BinaryWriter.create()) {
    if (message.contractAddress !== "") {
      writer.uint32(10).string(message.contractAddress);
    }
    if (message.walletAddress !== "") {
      writer.uint32(18).string(message.walletAddress);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayWalletIsEligible();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.contractAddress = reader.string();
          break;
        case 2:
          message.walletAddress = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$contractAddre3, _object$walletAddress2;
    const message = createBaseQueryFeePayWalletIsEligible();
    message.contractAddress = (_object$contractAddre3 = object.contractAddress) !== null && _object$contractAddre3 !== void 0 ? _object$contractAddre3 : "";
    message.walletAddress = (_object$walletAddress2 = object.walletAddress) !== null && _object$walletAddress2 !== void 0 ? _object$walletAddress2 : "";
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayWalletIsEligible();
    if (object.contract_address !== undefined && object.contract_address !== null) {
      message.contractAddress = object.contract_address;
    }
    if (object.wallet_address !== undefined && object.wallet_address !== null) {
      message.walletAddress = object.wallet_address;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.contract_address = message.contractAddress;
    obj.wallet_address = message.walletAddress;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayWalletIsEligible.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayWalletIsEligible.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayWalletIsEligible.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayWalletIsEligible",
      value: QueryFeePayWalletIsEligible.encode(message).finish()
    };
  }
};
function createBaseQueryFeePayWalletIsEligibleResponse() {
  return {
    eligible: false
  };
}
export const QueryFeePayWalletIsEligibleResponse = {
  typeUrl: "/juno.feepay.v1.QueryFeePayWalletIsEligibleResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.eligible === true) {
      writer.uint32(8).bool(message.eligible);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryFeePayWalletIsEligibleResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.eligible = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$eligible;
    const message = createBaseQueryFeePayWalletIsEligibleResponse();
    message.eligible = (_object$eligible = object.eligible) !== null && _object$eligible !== void 0 ? _object$eligible : false;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryFeePayWalletIsEligibleResponse();
    if (object.eligible !== undefined && object.eligible !== null) {
      message.eligible = object.eligible;
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.eligible = message.eligible;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryFeePayWalletIsEligibleResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryFeePayWalletIsEligibleResponse.decode(message.value);
  },
  toProto(message) {
    return QueryFeePayWalletIsEligibleResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryFeePayWalletIsEligibleResponse",
      value: QueryFeePayWalletIsEligibleResponse.encode(message).finish()
    };
  }
};
function createBaseQueryParamsRequest() {
  return {};
}
export const QueryParamsRequest = {
  typeUrl: "/juno.feepay.v1.QueryParamsRequest",
  encode(_, writer = BinaryWriter.create()) {
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },
  fromAmino(_) {
    const message = createBaseQueryParamsRequest();
    return message;
  },
  toAmino(_) {
    const obj = {};
    return obj;
  },
  fromAminoMsg(object) {
    return QueryParamsRequest.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryParamsRequest.decode(message.value);
  },
  toProto(message) {
    return QueryParamsRequest.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryParamsRequest",
      value: QueryParamsRequest.encode(message).finish()
    };
  }
};
function createBaseQueryParamsResponse() {
  return {
    params: Params.fromPartial({})
  };
}
export const QueryParamsResponse = {
  typeUrl: "/juno.feepay.v1.QueryParamsResponse",
  encode(message, writer = BinaryWriter.create()) {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseQueryParamsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.params = Params.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    const message = createBaseQueryParamsResponse();
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    return message;
  },
  fromAmino(object) {
    const message = createBaseQueryParamsResponse();
    if (object.params !== undefined && object.params !== null) {
      message.params = Params.fromAmino(object.params);
    }
    return message;
  },
  toAmino(message) {
    const obj = {};
    obj.params = message.params ? Params.toAmino(message.params) : undefined;
    return obj;
  },
  fromAminoMsg(object) {
    return QueryParamsResponse.fromAmino(object.value);
  },
  fromProtoMsg(message) {
    return QueryParamsResponse.decode(message.value);
  },
  toProto(message) {
    return QueryParamsResponse.encode(message).finish();
  },
  toProtoMsg(message) {
    return {
      typeUrl: "/juno.feepay.v1.QueryParamsResponse",
      value: QueryParamsResponse.encode(message).finish()
    };
  }
};